// manapp (not upstream): the DataGrid's own translation catalogue (ADR-0013, ADR-0018: we never load
// Medusa's dashboard translation files). Messages use ICU MessageFormat, matching `createI18n`.
// The web app deep-merges these into its `translation` namespace; the grid also falls back to the
// English text below when a key is missing, so it never renders a raw key.
import en from "./en.json"
import et from "./et.json"
import ru from "./ru.json"

export const dataGridLocales = { en, et, ru } as const

export type DataGridLocaleCatalogue = typeof en
